var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEdit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 6 6",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V6H6V2.12146L5.01562 3.10583V5.01562H0.984375V0.984375H2.89417L3.87854 0H0ZM5.25 0L4.86584 0.384155L5.61584 1.13415L6 0.75L5.25 0ZM4.68457 0.56543L2.48584 2.76416L3.23584 3.51416L5.43457 1.31543L4.68457 0.56543ZM2.20971 3.11169C2.19859 3.11186 2.18725 3.11267 2.17602 3.11352V3.82397H2.88647C2.88647 3.63043 2.79401 3.43378 2.6499 3.29626C2.53069 3.18251 2.37653 3.10912 2.20971 3.11169Z",
    fill: "#FFFFFF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.cb8f675e.svg";
export { ForwardRef as ReactComponent };